import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Header extends Component {
	render() {
		const { children } = this.props;
		return <div className="window-layout-header">{children}</div>;
	}
}

Header.propTypes = {
	children: PropTypes.node
};

export default Header;
